var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 10.625H10.625C12.3509 10.625 13.75 9.22589 13.75 7.5C13.75 5.77411 12.3509 4.375 10.625 4.375H4.375M4.375 10.625C2.64911 10.625 1.25 9.22589 1.25 7.5C1.25 5.77411 2.64911 4.375 4.375 4.375M4.375 10.625C6.10089 10.625 7.5 9.22589 7.5 7.5C7.5 5.77411 6.10089 4.375 4.375 4.375",
    stroke: "#898F9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/status-icon.9a995ec1e2a4031c5be603285da6c125.svg";
export { ForwardRef as ReactComponent };